<template>
  <transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-4"
  >
    <div
      v-if="visible"
      class="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-[60] flex justify-center pointer-events-none"
      role="dialog"
      aria-live="polite"
      aria-label="Çerez bildirimi"
    >
      <div class="rounded-card bg-white border border-stone p-6 md:p-7 max-w-3xl w-full pointer-events-auto">
        <div class="flex flex-col md:flex-row md:items-start gap-4 md:gap-6">
          <div class="flex-shrink-0 hidden md:flex">
            <span class="w-12 h-12 rounded-full bg-parchment flex items-center justify-center text-primary">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21.17 8A10 10 0 1016 21.17M8 12h.01M12 16h.01M16 8h.01M12 8h.01M16 13h.01" />
              </svg>
            </span>
          </div>

          <div class="flex-1">
            <p class="text-xs font-medium tracking-label uppercase text-graphite">Çerez Bildirimi</p>
            <h3 class="mt-2 text-lg md:text-xl font-medium text-primary leading-tight tracking-display">
              Deneyimini iyileştirmek için çerez kullanıyoruz.
            </h3>
            <p class="mt-2 text-sm text-graphite leading-relaxed">
              Site içi analitik, tercih hatırlatma ve içerik kişiselleştirme için çerezler kullanıyoruz.
              Zorunlu çerezler her zaman aktiftir. Detaylar için
              <a href="/privacy" class="underline decoration-secondary decoration-2 underline-offset-2 hover:text-primary">gizlilik politikamızı</a>
              inceleyebilirsin.
            </p>
          </div>

          <div class="flex flex-col sm:flex-row md:flex-col gap-2 md:w-44 md:flex-shrink-0">
            <button
              @click="accept"
              class="inline-flex items-center justify-center px-5 py-3 rounded-btn border border-primary bg-secondary text-primary text-sm font-medium hover:bg-primary hover:text-secondary transition-colors"
            >
              Tümünü kabul et
            </button>
            <button
              @click="reject"
              class="inline-flex items-center justify-center px-5 py-3 rounded-btn border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-cream transition-colors"
            >
              Reddet
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

const STORAGE_KEY = 'bloqin_cookie_consent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default defineComponent({
  name: 'CookieBar',
  setup() {
    const visible = ref(false);

    const applyConsent = (granted: boolean) => {
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: granted ? 'granted' : 'denied',
          analytics_storage: granted ? 'granted' : 'denied',
          ad_user_data: granted ? 'granted' : 'denied',
          ad_personalization: granted ? 'granted' : 'denied',
        });
      }
    };

    const accept = () => {
      localStorage.setItem(STORAGE_KEY, 'accepted');
      applyConsent(true);
      visible.value = false;
    };

    const reject = () => {
      localStorage.setItem(STORAGE_KEY, 'rejected');
      applyConsent(false);
      visible.value = false;
    };

    onMounted(() => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
          visible.value = true;
        } else {
          applyConsent(stored === 'accepted');
        }
      } catch {
        visible.value = true;
      }
    });

    return { visible, accept, reject };
  },
});
</script>
